import { Grid } from "@mui/material";
import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";

import RelationGuestComponent from "../Components/RelationGuestComponent";
import MobileNavbar from "../Components/MobileNavbar";

function GuestLogin() {
  return (
    <Grid container>
      <MobileNavbar text={"VISITOR FORM"}/>
      <RelationGuestComponent />
      <Footer />
    </Grid>
  );
}

export default GuestLogin;
